import { h } from 'preact'
import classNames from 'classnames'

import DropdownControl from '../../preact-components/dropdown/DropdownControl'
import Button from '@insided/control/uikit/Button'
import ListSelector from '../../preact-components/list-selector/ListSelector'
import { User } from '../../preact-components/user-selector/User'
import UserList from '../../preact-components/list-selector/UserList'
import UserAvatar from '../../preact-components/User/UserAvatar'
import { AuthorLite } from '@insided/control/modules/ContentModeration/TopicModeration/interfaces'

const AuthorSelector = ({ selected, onChange }: {
  selected: AuthorLite | undefined
  onChange: (author: AuthorLite) => void
}) => {
  const DropdownText = () => {
    return (
      selected
        ? <span className='selected'>
          <div>
            <UserAvatar
              disableLink
              disablePopup
              user={{
                id: selected.id,
                name: selected.username,
                avatar: selected.avatar
              }}
            />
          </div>
          <div className='truncated'>{selected.username}</div>
        </span>
        : <span>Choose an Author</span>
    )
  }

  const className = classNames('author-selector qa-author-selector', !selected && 'no-author-selected-message')

  return (
    <div className='author-selector-wrapper'>
      <DropdownControl
        align='adjust'
        trigger={
          <Button
            title={<DropdownText />}
            className={className}
            icon='arrowDropdown'
            size='medium'
          />
        }
        items={[]}
        hasSearch
        showDefaultChildren
        closeOnDropdownClick
      >
        {({ close }: { close: () => void }) =>
          <ListSelector
            align='left'
            isDynamic
            hasSearch
            fetchUrl='/member/getAuthors?filterByRole=1&query='
            placeholder='Search by username'
          >
            {(users: User[]) => <div>
              <UserList
                users={users} onClick={(user: User) => {
                  onChange({
                    id: user.id.toString(),
                    username: user.name,
                    avatar: user.avatar ?? ''
                  })
                  close()
                }}
              />
            </div>}
          </ListSelector>}
      </DropdownControl>
    </div>
  )
}

export default AuthorSelector
